import locales from "../I18n/locales";

const configsByTheme = (appTheme = "") => {
    switch (appTheme) {
        case "sovos":
            return {
                icon: "sovos-logo",
                defaultLocale: "en",
                contactEmailPerTheme: "sovos@sovos.com",
                loginApplicationName: "APR SAF-T",
                logoHorizontalDisplay: true,
                locales: locales(),
            };
        case "at-cv":
            return {
                icon: "logo",
                defaultLocale: "pt",
                contactEmailPerTheme: "contact.center@petapilot.com",
                loginApplicationName: null,
                locales: [
                    {
                        id: "en",
                        name: "EN",
                    },
                    {
                        id: "pt",
                        name: "PT",
                    },
                ],
            };
        case "klepierre":
            return {
                icon: "klepierre-logo",
                defaultLocale: "pt",
                contactEmailPerTheme: "",
                loginApplicationName: null,
                locales: [
                    {
                        id: "en",
                        name: "EN",
                    },
                    {
                        id: "pt",
                        name: "PT",
                    },
                ],
            };
        default:
            return {
                icon: "sovos-logo",
                defaultLocale: "en",
                contactEmailPerTheme: "sovos@sovos.com",
                loginApplicationName: "APR SAF-T",
                logoHorizontalDisplay: true,
                locales: locales(),
            };
    }
};

export default configsByTheme;
